import { fetchRequest } from "@providers/conect";

const getBoldResponsesApi = async (data = {}) => {
  try {
    const url = `webhook/bold/all`;
    const response = await fetchRequest(url, {
      method: "POST", // Cambiado a POST para enviar body
      body: { ...data }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { getBoldResponsesApi };